import React, { useState, useContext } from 'react';

// Context
import { UserContext } from '../../Context/UserContextProvider';

// components
import DashboardHeader from '../DashboardReuseAbleComponents/DashboardHeader';
import DashboardSideMenu from '../DashboardReuseAbleComponents/DashboardSideMenu';
import ShowProfileModal from '../DashboardFileManagement/CardDetail/ShowProfileModal';
import MyAccountInfo from './MyAccountInfo';

// Styles
import styles from "./MyAccount.module.css";

// Images
import arrowIcon from "./../../../assets/img/DashboardICons/ArrowRounded.svg"
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const MyAccount = () => {
    const { consultantData, userToken } = useContext(UserContext);
    const [modalShow, setModalShow] = useState(false);
    const history = useHistory();
    // console.log(consultantData)

    // console.log(consultantData)

    return (
        <>
            <ShowProfileModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                onMyAccount="#"
            />

            <div className='container-fluid'>
                <div className='row'>
                    <div className="col-md-9" >
                        <div className={`mt-3 px-0 ${styles.file_cards_container}`}>
                            <DashboardHeader onClick={() => setModalShow(true)} class="px-0" />

                            <div
                                className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-4 mx-4 px-2"
                                dir="rtl"
                            >
                                <div className='w-100 d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2'>
                                    <a href='#' onClick={history.goBack}><img className='ms-2' src={arrowIcon} alt="icon" /></a>
                                    <div className={styles.text1}>
                                        حساب کاربری
                                    </div>
                                </div>
                            </div>

                            {/* My Account Info */}
                            <MyAccountInfo avatarName={consultantData?.imageUrl} userData={consultantData} userToken={userToken}/>

                        </div>
                    </div>
                    <div className='col-md-3'>
                        {/* sideMenu starts */}
                        <DashboardSideMenu />
                        {/* sideMenu ends */}
                    </div>
                </div>
            </div>
        </>
    )

}

export default MyAccount